const { getElement } = window.BAO.Utils
const { convertToDOM } = window.BAO.sectionRenderer

class ProductColours extends window.BAO.CustomElement() {
  static get requiredElements () {
    return ['title']
  }

  connectedCallback () {
    super.connectedCallback()
  }

  setupListeners () {
    super.setupListeners()

    if (!this.els?.colour?.elements) return

    this.listeners.add(this, 'click', this.handleClick.bind(this))

    if (!window.BAO.MediaBreakpoints.isMd) return

    this.handleMouseEnter = this.handleMouseEnter.bind(this)
    this.handleMouseLeave = this.handleMouseLeave.bind(this)

    this.els.colour.elements.forEach(colour => {
      this.listeners.add(colour, 'mouseenter', this.handleMouseEnter)
      this.listeners.add(colour, 'mouseleave', this.handleMouseLeave)
    })
  }

  async handleClick (event) {
    if (!event.target.closest(this.els.colour.selector)) return
    event.preventDefault()

    const nextUrl =
      event.target.getAttribute('href') ||
      event.target.parentElement.getAttribute('href')

    const response = await fetch(`${nextUrl}`)
    const responseHTML = await response.text()
    const responseDOM = convertToDOM(responseHTML)

    // Product details section
    const currentSectionEl = getElement('product-detail', { context: document })
    const newSectionEl = getElement('product-detail', { context: responseDOM })
    if (currentSectionEl && newSectionEl) {
      currentSectionEl.outerHTML = newSectionEl.outerHTML
    }

    // Size guide section
    const currentSizeGuideEl = getElement('size-guide', { context: document })
    const newSizeGuideEl = getElement('size-guide', { context: responseDOM })
    if (currentSizeGuideEl && newSizeGuideEl) {
      currentSizeGuideEl.outerHTML = newSizeGuideEl.outerHTML
    }

    // Complete the style section
    const currentCompleteTheStyleEl = getElement(
      '[data-section-type="complete-the-style"]',
      {
        context: document,
      },
    )
    const newCompleteTheStyleEl = getElement(
      '[data-section-type="complete-the-style"]',
      {
        context: responseDOM,
      },
    )
    if (currentCompleteTheStyleEl && newCompleteTheStyleEl) {
      currentCompleteTheStyleEl.outerHTML = newCompleteTheStyleEl.outerHTML
    }

    // Complete the style drawer content
    const currentCompleteTheStyleDrawerEl = getElement(
      '[data-section-type="complete-the-style-drawer"]',
      {
        context: document,
      },
    )
    const newCompleteTheStyleDrawerEl = getElement(
      '[data-section-type="complete-the-style-drawer"]',
      {
        context: responseDOM,
      },
    )
    if (currentCompleteTheStyleDrawerEl && newCompleteTheStyleDrawerEl) {
      currentCompleteTheStyleDrawerEl.outerHTML =
        newCompleteTheStyleDrawerEl.outerHTML
    }

    // Related Products
    const currentRelatedProductsEl = getElement(
      '[data-section-type="related-products"]',
      {
        context: document,
      },
    )
    const newRelatedProductsEl = getElement(
      '[data-section-type="related-products"]',
      {
        context: responseDOM,
      },
    )
    if (currentRelatedProductsEl && newRelatedProductsEl) {
      currentRelatedProductsEl.outerHTML = newRelatedProductsEl.outerHTML
    }

    // product recommended for you
    const currentRecommendedForYouEl = getElement(
      '[data-section-type="product-recommended-for-you"]',
      {
        context: document,
      },
    )
    const newRecommendedForYouEl = getElement(
      '[data-section-type="product-recommended-for-you"]',
      {
        context: responseDOM,
      },
    )
    if (currentRecommendedForYouEl && newRecommendedForYouEl) {
      currentRecommendedForYouEl.outerHTML = newRecommendedForYouEl.outerHTML
    }

    // product recently viewed
    const currentRecentlyViewedEl = getElement(
      '[data-section-type="product-recently-viewed"]',
      {
        context: document,
      },
    )
    const newRecentlyViewedEl = getElement(
      '[data-section-type="product-recently-viewed"]',
      {
        context: responseDOM,
      },
    )
    if (currentRecentlyViewedEl && newRecentlyViewedEl) {
      currentRecentlyViewedEl.outerHTML = newRecentlyViewedEl.outerHTML
    }

    const newProductId = newRelatedProductsEl?.dataset?.productId
    if (newProductId) {
      // Related Products are overridden by Tagalys. To ensure content is refreshed after the
      // content is updated, we dispatch a custom event which is heard in `Tagalys.liquid`
      // and then refreshed.
      document.dispatchEvent(
        new CustomEvent('RelatedProductsRefresh', {
          detail: {
            productId: newProductId,
          },
          bubbles: true,
        }),
      )
    }

    // Title el
    const newTitleEl = getElement('title', { context: responseDOM })
    const newTitle = newTitleEl.innerHTML

    if (window.history.replaceState) {
      window.history.replaceState({}, newTitle, nextUrl)
    }
    document.title = newTitle

    window.dataLayer.push({
      event: 'productColourSelected',
      productHandle: this.dataset.handle,
      colour: event.target.dataset.title || event.target.textContent,
    })
  }

  handleMouseEnter (e) {
    this.els.title.elements.forEach(el => {
      el.textContent = e.currentTarget.dataset.title
    })
  }

  handleMouseLeave (e) {
    this.els.title.elements.forEach(el => {
      el.textContent = el.dataset.defaultColour
    })
  }
}

if (!customElements.get('product-colours')) {
  customElements.define('product-colours', ProductColours)
}
